import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-women-empowerment',
  templateUrl: './women-empowerment.component.html',
  styleUrls: ['./women-empowerment.component.scss']
})
export class WomenEmpowermentComponent implements AfterViewInit {

  constructor() { }

 ngAfterViewInit(): void {
 }
}



